import PropTypes from 'prop-types';

const AboutUs = ({data}) => {
  return (
    <div className={'w-full flex  flex-col justify-center items-center lg:px-24 px-5 lg:py-10 py-4 mt-5'}>
     
      {/* Our Design Approach */}
      <div>
        <div className={'flex justify-start w-full'}>
          <h1 className={'playfair-display-medium font-bold lg:text-6xl text-3xl text-primary-900'}>Our Vision</h1>
        </div>
        <div className={'grid lg:grid-cols-3 grid-cols-1 gap-4 lg:mt-10 mt-8 max-w-7xl'} data-aos={'fade-up'}>
          {data.cards.map((card, index) => (
            <div key={index} className={'card p-6 shadow-md rounded-3xl bg-primary-50'}>
              <img src={card.image} alt={card.title} className={'w-full lg:h-56 h-60 object-cover mb-5 rounded-xl'} />
              <h2 className={'text-2xl font-extrabold mb-2 prata'}>{card.title}</h2>
              <p className={'text-justify text-base font-sans'}>{card.description}</p>
            </div>
          ))}
        </div>

        {/* Why Choose Us / Craftsmanship */}
        <div className={'mt-10 flex justify-start w-full'}>
          <h1 className={'playfair-display-medium font-bold lg:text-6xl text-3xl lg:mt-10 mt-8 text-primary-900'}>
         The Art of Fine Craftsmanship
          </h1>
        </div>

        <div className={'mb-16 flex flex-col lg:flex-row p-6 shadow-md rounded-3xl bg-primary-50 lg:mt-10 mt-8 max-w-7xl'} data-aos={'fade-up'}>
          <img
            src={data.cards1[0].image}
            alt={data.cards1[0].title}
            className={'w-full lg:w-1/3 lg:h-60 h-60 object-cover mb-5 rounded-xl'}
          />
          <div className={'lg:ml-5 lg:w-2/3'}>
            <h2 className={'text-2xl font-extrabold mb-2 prata'}>{data.cards1[0].title}</h2>
            <p className={'text-justify text-lg font-sans mt-5'}>{data.cards1[0].description}</p>
          </div>
        </div>

        {/* Our story */}
        <h1 className={'w-full text-start playfair-display-medium font-bold lg:text-6xl text-3xl mt-10 text-primary-900'}>{data.title}</h1>
        <div className={'grid lg:grid-cols-2 grid-cols-1 lg:gap-10 gap-5 lg:mt-10 mt-7 max-w-7xl'} data-aos={'fade-up'}>
          <div>
            <div className={'h-96 w-full'}>
              <img src={data.image} alt={'home'} className={'object-cover w-full h-full rounded-xl'}></img>
            </div>
          </div>
          <div>
            <h1 className={'playfair-display-medium font-bold lg:text-6xl text-4xl text-primary-900'}>{data.title1}</h1>
            <p className={'lg:mt-7 mt-5 font-sans text-xl text-justify'}>{data.description}</p>
          </div>  
        </div>
      </div>
    </div>
  );
};

AboutUs.propTypes = {
  data: PropTypes.shape,
};

export default AboutUs;
